import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Toggle } from 'frontend/js/modules/infra/dls/components/toggle';
import styles from '../styles.module.scss';
export var ToggleColumn = function (_a) {
    var isEnabled = _a.isEnabled, campaignId = _a.campaignId, onToggle = _a.onToggle;
    // TODO: implement the actual logic here
    var _b = useState(isEnabled), checked = _b[0], setChecked = _b[1];
    return (_jsx("div", { className: styles['toggle-column-wrapper'], children: _jsx(Toggle, { id: "automated-toggle-".concat(campaignId), checked: checked, onChange: function (newChecked) {
                setChecked(newChecked);
                onToggle();
            }, className: styles.center }) }));
};
